import { endpoint, EndpointError } from 'endpoints/endpoint';

export type ExportLeadsResult = Buffer;
export type ExportLeadsError = EndpointError;

export const exportLeads = endpoint<void, ExportLeadsResult, ExportLeadsError>({
  method: 'GET',
  url: () => `/csv/export-leads/:leadType`,
});
